import { useHistory } from 'react-router-dom';
import { IWTButton } from '../IWTButton';
import { Pages } from '../../../utils/constants';
import { UtagHelper } from '../../../utils/UtagHelper';
import { generateMembershipCardUrl } from '../../../utils/generateURL';

export interface MembershipCardIWTProps {
  variant?: 'small';
}

export const MembershipCardIWT = ({ variant }: MembershipCardIWTProps) => {
  const history = useHistory();

  return (
    <>
      <IWTButton
        title="Get membership card"
        id="MembershipCardIWT"
        variant={variant}
        onClick={() => {
          window.open(generateMembershipCardUrl(), '_blank');
        }}
      />
    </>
  );
};
